import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { Tab } from '../../models/tab';
import { DexieService } from '../../services/dexie.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Scene } from '../../models/scene';
import { SceneService } from '../../services/scene.service';
import Dexie from 'dexie';

@Component({
	selector: 'app-content',
	templateUrl: './content.component.html',
	styleUrls: ['./content.component.scss']
})

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Content Component.
 */
export class ContentComponent implements OnInit, OnDestroy
{
	/**
	 * Scene.
	 */
	public scene: Scene;

	/**
	 * Store in IndexedDB.
	 */
	private store: Dexie.Table<any, string>;

	/**
	 * Content.
	 */
	private content: number;

	/**
	 * Tabs.
	 */
	public tabs: Tab[];

	/**
	 * Language.
	 */
	public language: string;

	/**
	 * Subscripton for the language.
	 */
	private languageSubscription: Subscription;

	/**
	 * Constructor.
	 */
	public constructor(
		private db: DexieService,
		private route: ActivatedRoute,
		private translateService: TranslateService,
		private sceneService: SceneService,
		private router: Router
	)
	{
		this.store = this.db.table('contents');
	}

	/**
	 * Lifecycle-Hook: OnInit.
	 */
	public ngOnInit()
	{
		this.scene = this.sceneService.getActiveScene();

		this.route.params.subscribe(params => {

			this.content = +params['content'];

			this.store.get({id: this.content}).then(content => {
				if (content && content.tabs)
				{
					this.tabs = content.tabs;

					if (this.router.url != '/portal/content/' + this.content + '/form' && !params['tab'])
					{
						this.router.navigate(['/portal/content/', this.content, 'tab', this.tabs[0].id]);
					}
				}
			});
		});

		// Language.
		this.language = this.translateService.currentLang;
		this.languageSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
			this.language = event.lang;
		});
	}

	/**
	 * Lifecycle-Hook: OnDestroy.
	 */
	public ngOnDestroy()
	{
		this.languageSubscription.unsubscribe();
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/content/content.component.ts